import HoverTooltip from 'components/common/HoverTooltip';
import React, { useState } from 'react';
import { GiKeyCard } from 'react-icons/gi';

interface Props {
    keyTag: string;
    onSave: (keyTag: string) => void;
}

const KeyTag: React.FC<Props> = (props: Props) => {
    const [isKeyTagInputOpen, setIsKeyTagInputOpen] = useState(false);
    const [keyTag, setKeyTag] = useState(props.keyTag);

    const toggleState = () => {
        if (isKeyTagInputOpen) {
            props.onSave(keyTag);
        }
        setIsKeyTagInputOpen(!isKeyTagInputOpen);
    };

    return (
        <div className="rounded-lg border bg-white inline-block p-2 ml-2">
            <div className="mr-2 inline">
                <HoverTooltip content={<div className="b">Key Tag</div>} isSmall>
                    <GiKeyCard
                        className="clickable inline text-2xl"
                        onClick={() => setIsKeyTagInputOpen(!isKeyTagInputOpen)}
                    />
                </HoverTooltip>
            </div>
            <input
                className="border border-blue-200 rounded-lg px-2 pt-0 w-24 disabled:border-0 mr-4"
                disabled={!isKeyTagInputOpen}
                value={keyTag || undefined}
                onChange={(e: any) => {
                    setKeyTag(e.target.value);
                }}
                autoFocus
            />

            <button className="p-1 rounded-lg bg-green-600 font-semibold text-sm px-2" onClick={() => toggleState()}>
                {isKeyTagInputOpen ? 'Save' : 'Edit'}
            </button>
        </div>
    );
};

export default KeyTag;
